<mat-sidenav-container class="site-layout-sidenav-container">
   <mat-sidenav-content style="overflow: unset">
      <ndt-site-layout-view
         [currentUser]="currentUser$ | async"
         [menuItems]="menuItems$ | async"
         [menuExpanded]="menuExpanded$ | async"
         [mobileView]="mobileView$ | async"
         [tabletView]="tabletView$ | async"
         [showCallQueues]="showCallQueues$ | async"
         [showTopBar]="showTopBar$ | async"
         [isLocalUser]="isLocalUser$ | async"
         [adminToken]="adminToken$ | async"
         [searchText]="searchText$ | async"
         [selectedAccountName]="selectedAccountName$ | async"
         [isOnSystemPage]="isOnSystemPage$ | async"
         (signOutClicked)="onSignOutClick()"
         (toggleMenuClicked)="onToggleMenuClicked($event)"
         (toggleShowExtensionRegisterPopup)="toggleShowExtensionRegisterPopup($event)"
         [showExtensionRegisterPopup]="showExtensionRegisterPopup$ | async"
         (customerViewClicked)="onCustomerViewClicked($event)"
         (userPreferencesClicked)="onUserPreferencesClicked()"
      ></ndt-site-layout-view>
   </mat-sidenav-content>

   <mat-sidenav class="list-management" #startSidenav mode="over" position="start" fixedInViewport cdkScrollable>
      <ndt-site-sidenav-content [position]="'start'"></ndt-site-sidenav-content>
   </mat-sidenav>
   <mat-sidenav class="filter-drawer" #endSidenav mode="over" position="end" fixedInViewport cdkScrollable>
      <ndt-site-sidenav-content [position]="'end'"></ndt-site-sidenav-content>
   </mat-sidenav>
</mat-sidenav-container>
